<template>
  <div class="onePurchase" id="onePurchase">
    <a-layout>
      <a-layout-header>
        <PageNav></PageNav>
      </a-layout-header>
      <a-layout-content>
        <div class="content_wrap">
          <div class="content_main">
            <div class="content_header"></div>
            <div class="content_center">
              <div class="tabBox">
                <swiper :nacigation="nacigation" :space-between="10" class="tabList" :loop="false"
                        :slides-per-view="slidesPer">
                  <swiper-slide class="tabItem" :class="atDfa === index ? 'active' : ''" v-for="(item,index) in tabList" :key="index" @click="aciChange(index)">
                    <div class="_column" v-show="atDfa !== index">
                      <span class="label">{{ item.label }}</span>
                      <span class="txt">{{ item.stage }}</span>
                    </div>
                    <div class="_column">
                      <span class="title" v-show="atDfa === index">{{ $t('one_purchase.current_stage', { stage: item.stage }) }}</span>
                    </div>
                  </swiper-slide>
                </swiper>
              </div>
              <div class="content_center_main">
                <div class="left">
                  <p class="title">{{ $t('one_purchase.participants_buying') }}</p>
                  <div class="runnings"></div>
                </div>
                <div class="game">
                  <div class="price">
                    <span>{{ $t('one_purchase.prize') }}</span>
                    <span>188</span>
                    <span>USDT</span>
                  </div>
                  <!-- process-main-->
                  <div class="process_main">
                    <a-progress class="process" :animation="true" :show-text="false" status='danger' :percent="0.6" />
                    <div class="process_num">
                      <span>{{ $t('one_purchase.draw_progress') }}</span>
                      <div class="_flex">
                        <span>86</span>
                        <span>/188</span>
                      </div>
                    </div>
                  </div>
                  <!--rule-->
                  <div class="rule">
                    <span>{{ $t('one_purchase.how_to_play') }}</span>
                    <span>{{ $t('one_purchase.rules') }}</span>
                  </div>
                  <!--screen-main-->
                  <div class="screen_main">
                    <p class="once">{{ $t('one_purchase.ticket_price') }}</p>
                    <div class="rounds">
                      <div class="rdItem active" v-for="item in roundsList">
                        <span>{{ item }}</span>
                      </div>
                    </div>
                  </div>
                  <!--pay-main-->
                  <div class="pay_main">
                    <div class="pays">
                      <div class="has-money">
                        <span>{{ $t('flashswap.pay') }}</span>
                      </div>
                      <div class="pay-money">
                        <span>1,000 DBG</span>
                      </div>
                      <div class="batch batch-left-top" :class="batchActive == 0 ? 'active' : ''" @click="batchActive = 0">
                          <span>{{ $t('one_purchase.ticket_count', { count: 1 }) }}</span>
                      </div>
                      <div class="batch batch-left-bottom" :class="batchActive == 1 ? 'active' : ''" @click="batchActive = 1">
                        <span>{{ $t('one_purchase.ticket_count', { count: 5 }) }}</span>
                      </div>
                      <div class="batch batch-right" :class="batchActive == 2 ? 'activeRight' : ''" @click="batchActive = 2">
                      <span>{{ $t('one_purchase.ticket_count', { count: 10 }) }}</span>
                      </div>
                      <div class="batch batch-right-bottom" :class="batchActive == 3 ? 'activeRight' : ''" @click="batchActive = 3">
                        <span>{{ $t('one_purchase.ticket_count', { count: 20 }) }}</span>
                      </div>
                    </div>
                  </div>

                  <!--userinfo-->
                  <div class="userinfo">
                      <div class="login">
                        <span>{{ $t('bind_box.click_to') }}</span>
                        <span>{{ $t('common.login') }}/</span>
                        <span>{{ $t('common.register') }}</span>
                      </div>
                  </div>

                  <!--game-buttons-->
                  <div class="game-buttons">
                    <div class="button" :class="btnActive === 0 ? 'btn-active' : ''" @click="btnActive = 0" >
                      <span>{{ $t('one_purchase.ongoing') }}</span>
                    </div>
                    <div class="button" :class="btnActive === 1 ? 'btn-active' : ''" @click="btnActive = 1">
                      <span>{{ $t('one_purchase.my_participations') }}</span>
                    </div>
                    <div class="button" :class="btnActive === 2 ? 'btn-active' : ''" @click="btnActive = 2">
                      <span>{{ $t('one_purchase.previous_rounds') }}</span>
                    </div>
                  </div>
                </div>
                <div class="my-number">
                  <p class="title">{{ $t('one_purchase.round_my_numbers', { round: 75022 }) }}</p>
                  <div class="number-list">
                    <div class="number-list-item">
                      <span class="sort">1</span>
                      <div class="rounds">
                        <div class="_i"></div>
                        <div class="_i"></div>
                        <div class="_i"></div>
                        <div class="_i"></div>
                        <div class="_i"></div>
                        <div class="_i"></div>
                        <div class="_i"></div>
                      </div>
                    </div>
                    <div class="number-list-item">
                      <span class="sort">1</span>
                      <div class="rounds">
                        <div class="_i"></div>
                        <div class="_i"></div>
                        <div class="_i"></div>
                        <div class="_i"></div>
                        <div class="_i"></div>
                        <div class="_i"></div>
                        <div class="_i"></div>
                      </div>
                    </div>
                    <div class="number-list-item">
                      <span class="sort">1</span>
                      <div class="rounds">
                        <div class="_i"></div>
                        <div class="_i"></div>
                        <div class="_i"></div>
                        <div class="_i"></div>
                        <div class="_i"></div>
                        <div class="_i"></div>
                        <div class="_i"></div>
                      </div>
                    </div>
                    <div class="number-list-item">
                      <span class="sort">1</span>
                      <div class="rounds">
                        <div class="_i"></div>
                        <div class="_i"></div>
                        <div class="_i"></div>
                        <div class="_i"></div>
                        <div class="_i"></div>
                        <div class="_i"></div>
                        <div class="_i"></div>
                      </div>
                    </div>
                    <div class="number-list-item">
                      <span class="sort">1</span>
                      <div class="rounds">
                        <div class="_i"></div>
                        <div class="_i"></div>
                        <div class="_i"></div>
                        <div class="_i"></div>
                        <div class="_i"></div>
                        <div class="_i"></div>
                        <div class="_i"></div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </a-layout-content>
      <a-layout-footer>
        <Footer></Footer>
      </a-layout-footer>
    </a-layout>
  </div>
</template>
<script>
import PageNav from "@/components/PageNav/PageNav.vue";
import Footer from "@/components/Footer/footer.vue";
import {Swiper, SwiperSlide} from "swiper/vue";

export  default {
  components: {Swiper, SwiperSlide, PageNav, Footer},
  data(){
    return {
      atDfa: 0,
      slidesPer: 5,
      tabList:[{
        label:this.$t('one_purchase.prize_amount', { amount: '688,000 DBG' }),
        stage:"480261期"
      },{
        label:this.$t('one_purchase.prize_amount', { amount: '688,000 DBG' }),
        stage:"480261期"
      },{
        label:this.$t('one_purchase.prize_amount', { amount: '688,000 DBG' }),
        stage:"480261期"
      },{
        label:this.$t('one_purchase.prize_amount', { amount: '688,000 DBG' }),
        stage:"480261期"
      },{
        label:this.$t('one_purchase.prize_amount', { amount: '688,000 DBG' }),
        stage:"480261期"
      },{
        label:this.$t('one_purchase.prize_amount', { amount: '688,000 DBG' }),
        stage:"480261期"
      }],
      roundsList:["1","2","3","4","5","6","7"],
      batchActive:0,
      btnActive:0
    }
  },
  methods: {
    aciChange(index) {
      this.atDfa = index;
    }
  }
}
</script>
